import Service from '../../service'
import { apiOff } from '@/Plugins/Axios'

/**
 * @type {ApiOff}
 */
export default class ApiOff extends Service {
    constructor(options = {}) {
        super(options)
        this.http = apiOff
    }

	configurations(){
		return this.http.get('/configurations')
	}
}
